import React from 'react'

export interface BurgerProps {
    isOpen?: boolean
    onClick: Function
}

export const closeBurgerMenu = () => {
    document.querySelector<HTMLAnchorElement>('.header-container.open a.burger-wrapper')?.click()
}

export const Burger: React.FC<BurgerProps> = props => {
    const { isOpen, onClick } = props

    const onClickHandler = (event: React.MouseEvent) => {
        event.preventDefault()
        if (onClick) onClick()
    }

    const burgerClass = isOpen ? 'animate' : ''

    return (
        <div className="header-burger">
            <div className="burger-container">
                <a href="#" className="burger-wrapper" onClick={onClickHandler} data-testid="nav-mobile-burger">
                    <div className={`${burgerClass} burger-menu`}></div>
                </a>
            </div>
        </div>
    )
}
